'use client';

import classNames from 'classnames';
import { type ReactNode, useCallback, useEffect, useRef } from 'react';

import styles from './FullHeightStikyAside.module.scss';

interface Props {
    children?: ReactNode;
    className?: string;
}

export function FullHeightStikyAside({ children, className }: Props) {
    const ref = useRef<HTMLElement>(null);

    const calculateHeight = useCallback(() => {
        const element = ref.current;

        if (!element) {
            return;
        }

        const { top } = element.getBoundingClientRect();
        const computedStyle = getComputedStyle(element);
        const offsetBottom = parseInt(computedStyle.getPropertyValue('bottom'), 10);

        const newHeight = window.innerHeight - top - offsetBottom;

        element.style.setProperty('max-height', `${newHeight}px`);
    }, []);

    useEffect(() => {
        calculateHeight();

        window.addEventListener('scroll', calculateHeight);
        window.addEventListener('resize', calculateHeight);

        return () => {
            window.removeEventListener('scroll', calculateHeight);
            window.removeEventListener('resize', calculateHeight);
        };
    }, [calculateHeight]);

    return (
        <aside ref={ref} className={classNames(className, styles.aside)}>
            {children}
        </aside>
    );
}
